let discountInput, originalDiscountSubmitButton, cartIsEligible;
let drawerBody = document.querySelector('.drawer__body');
let discountCodeCampaignModal = document.getElementById('PopupModal-discount-code-campaign');
let discountCodeCampaignModalContent = document.querySelector('.discount-code-campaign-modal__content-wrapper');

let observer;
let periodicCheckInterval;

const isDiscountInput = (node) => {
  if (node.nodeType !== Node.ELEMENT_NODE || !node.matches) return false;
  
  return node.matches('.cart-discounts-input') || node.querySelector('.cart-discounts-input');
};

const setupMutationObserver = () => {
  if (observer) observer.disconnect();
  
  observer = new MutationObserver((mutations) => {
    const hasDiscountChanges = mutations.some(mutation => {
      if (mutation.type !== 'childList') return false;
      
      const addedNodes = Array.from(mutation.addedNodes);
      const removedNodes = Array.from(mutation.removedNodes);
      
      return [...addedNodes, ...removedNodes].some(isDiscountInput);
    });
    
    if (hasDiscountChanges) {
      setTimeout(addEventListenerToDiscountField, 100);
    }
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'id']
  });
};

const initDiscountField = () => {
  const discountInput = document.querySelector('.cart-discounts-input');
  
  if (discountInput) {
    addEventListenerToDiscountField();
  }
  
  setupMutationObserver();
};

initDiscountField();

document.addEventListener('shopify:section:load', () => {
  initDiscountField();
});

document.addEventListener('cart:updated', () => {
  initDiscountField();
});

function addEventListenerToDiscountField() {
  // Find elements
  discountInput = document.querySelector('.cart-discounts-input');
  originalDiscountSubmitButton = document.querySelector('.cart-discounts-apply');

  // Safety check - only proceed if elements exist
  if (!discountInput || !originalDiscountSubmitButton) {
    console.warn('Discount field elements not found, will retry on next mutation');
    return;
  }

  // Check if already bound to prevent duplicates
  if (discountInput.hasAttribute('data-discount-bound')) {
    return;
  }

  // Remove existing listeners to prevent duplicates
  try {
    discountInput.removeEventListener('keydown', handleKey);
    originalDiscountSubmitButton.removeEventListener('click', handleDiscount, { capture: true });
  } catch (e) {
    // Ignore errors if listeners weren't attached
  }

  // Add new listeners — capture: true ensures we run before cartDiscounts element listener
  discountInput.addEventListener('keydown', handleKey);
  originalDiscountSubmitButton.addEventListener('click', handleDiscount, { capture: true });
  
  // Mark as bound to prevent duplicate binding
  discountInput.setAttribute('data-discount-bound', 'true');
  
  console.log('Discount field listeners attached successfully');
  function handleKey(e) {
    if (e.key === "Enter") {
      handleDiscount(e);      
    }
  }

  async function handleDiscount(e) {
    e.preventDefault();
    cartIsEligible = false;
    let discountCodeValue = discountInput.value;
    let matchingDiscount = window.discountCoupons?.settings && window.discountCoupons?.settings?.find((coupon) => coupon.code === discountCodeValue);

    if (matchingDiscount?.is_influencer_code) {
      e.stopImmediatePropagation();
    }

    let minOrderValue = matchingDiscount?.min_order_value || window.discountCoupons?.min_order_value;
    let totalOfMatchingVariants = 0;

    let discountedVariantId = parseInt(matchingDiscount?.discounted_variant?.id);
    let fetchedCartItems = await fetch('/cart.js')
      .then((res) => res.json())
      .then((res) => {
        return res.items;
      });    
    
    if (matchingDiscount?.is_influencer_code) {
      cartIsEligible = true;
    } else if (minOrderValue) {
      fetchedCartItems.forEach((item) => {
        if (matchingDiscount?.variants_to_buy?.includes(item.variant_id))
        totalOfMatchingVariants += item.original_line_price;
      });
      if (minOrderValue <= totalOfMatchingVariants) cartIsEligible = true;
    } else {
      cartIsEligible = true;
    }
    
    let discountedVariantAlreadyInCart = fetchedCartItems?.find((item) => item.variant_id == discountedVariantId);

    let influencerGiftAlreadyInCart = fetchedCartItems?.find((item) => item.properties?._influencer_code);

    if (matchingDiscount && discountedVariantAlreadyInCart == undefined && cartIsEligible) {
      if (matchingDiscount.is_influencer_code) {
        if (influencerGiftAlreadyInCart) return;
        addInfluencerProductToCart(matchingDiscount.discounted_variant.id, discountCodeValue);
      } else {
        let discountedProductElm = document.createElement('div');
        discountedProductElm.classList.add('discounted-product');
        discountedProductElm.innerHTML = `
          <div class="discounted-product__content">
            <div class="discounted-product__header">
              <h4 class="discounted-product__title center"><i>${discountCoupons?.strings?.add_to_cart_to_apply}</i></h4>
            </div>
            <div class="discounted-product__image center">
              <img src="${matchingDiscount?.discounted_variant.image}" alt="${matchingDiscount?.discounted_variant.title}">
            </div>
            <div class="discounted-product__info">
              <h4 class="discounted-product__title center cart-item__name">${matchingDiscount?.discounted_variant.title}</h4>
            </div>
            <div class="discounted-product__actions">
              <button class="discounted-product__add-to-cart button button--primary" data-variant-id="${matchingDiscount?.discounted_variant.id}">Přidat do košíku</button>
            </div>
          </div>`;

        discountCodeCampaignModalContent.innerHTML = '';
        discountCodeCampaignModalContent.appendChild(discountedProductElm);
        discountCodeCampaignModal.setAttribute('open', '');

        let addToCartButton = document.querySelector('.discounted-product__add-to-cart');
        addToCartButton.addEventListener('click', (e) => {
          let variantId = e.target.getAttribute('data-variant-id');
          addDiscountedProductToCart(variantId);
        });
      }
    } else {
      // For influencer codes: never forward to native Shopify discount
      if (!matchingDiscount?.is_influencer_code) {
        if (e.key === "Enter") {
          originalDiscountSubmitButton.click();
        }
      }
    }
  }
}

async function addInfluencerProductToCart(variantId, influencerCode) {
  const formData = {
    items: [{ id: variantId, quantity: 1, properties: { _influencer_code: influencerCode } }]
  };
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    });
    const result = await response.json();
    if (result.items) {
      discountInput.value = '';
      const cartItemsEl = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
      if (cartItemsEl?.refreshCartUI) {
        await cartItemsEl.refreshCartUI();
      }
    } else {
      console.error('Influencer gift add failed:', result.message);
    }
  } catch (error) {
    console.error('Error adding influencer gift:', error);
  }
}

async function addDiscountedProductToCart(discountedVariantId) {
  let formData = {
  'items': [{
    'id': discountedVariantId,
    'quantity': 1
    }]
  };
  try {
    const response = await fetch(`/cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
    const result = await response.json();
    if (result.items) {
      if (result.items.length == 1) {
        discountCodeCampaignModal.removeAttribute('open');
        setTimeout(() => {
          originalDiscountSubmitButton.click();
        }, 1000);
      } 
    } else {
      document.querySelector('.discounted-product__actions').innerHTML = `<p>${result.message}</p>`;
    }
  } catch (error) {
    console.error('Error:', error);
  }
}